/**
 * Breed names for checkout analytics.
 *
 * Stored on the cart as `pet_breed_names` (Shopify key `_pet_breed_names`):
 * [{ pet_id, breeds: string[] }]. The checkout Segment pixel reads that
 * attribute with the same shape.
 */

export const serializeCartPetBreeds = pets => {
  const entries = (pets ?? [])
    .map(pet => ({
      pet_id: pet?.id != null ? String(pet.id) : '',
      breeds: (pet?.breeds ?? [])
        .map(breed => breed?.name)
        .filter(name => typeof name === 'string' && name),
    }))
    .filter(entry => entry.pet_id && entry.breeds.length);

  if (!entries.length) return null;
  return JSON.stringify(entries);
};
